
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Web3Provider } from "@/components/Web3Provider";
import { ErrorBoundary } from "@sentry/react";
import Index from "./pages/Index";
import Advanced from "./pages/Advanced";
import CoinDetail from "./pages/CoinDetail";
import Todo from "./pages/Todo";
import Analytics from "./pages/Analytics";
import CreateCoin from "./pages/CreateCoin";
import ReferralCodes from "./pages/ReferralCodes";
import { KingOfTheHill } from "@/components/KingOfTheHill/KingOfTheHill";
import PlatformMetrics from "./pages/PlatformMetrics";
import Moderation from "./pages/Moderation";
import Profile from "./pages/Profile";
import DaoIt from "./pages/DaoIt";
import ReferralDashboard from "./pages/ReferralDashboard";
import InceptionTokens from "./pages/InceptionTokens";
import Projects from "./pages/Projects";
import Entities from "./pages/Entities";
import Agents from "./pages/Agents";
import Validators from "./pages/Validators";
import Services from "./pages/Services";
import NftStudio from "./pages/NftStudio";

const queryClient = new QueryClient();

// Error fallback component
const FallbackComponent = () => (
  <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
    <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
    <p className="mb-4">We've been notified about this issue and are working to fix it.</p>
    <button 
      onClick={() => window.location.href = '/'}
      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
    >
      Go back to home page
    </button>
  </div>
);

const App = () => (
  <ErrorBoundary fallback={FallbackComponent}>
    <Web3Provider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/advanced" element={<Advanced />} />
              <Route path="/create-coin" element={<CreateCoin />} />
              <Route path="/coins/:coinId" element={<CoinDetail />} />
              <Route path="/todo" element={<Todo />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/referral-codes" element={<ReferralCodes />} />
              <Route path="/referrals" element={<ReferralDashboard />} />
              <Route path="/king-of-the-bots" element={<KingOfTheHill />} />
              <Route path="/king-of-the-hill" element={<KingOfTheHill />} />
              <Route path="/platform-metrics" element={<PlatformMetrics />} />
              <Route path="/moderation" element={<Moderation />} />
              <Route path="/profile/:address" element={<Profile />} />
              <Route path="/dao-it" element={<DaoIt />} />
              <Route path="/inception" element={<InceptionTokens />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/entities" element={<Entities />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/validators" element={<Validators />} />
              <Route path="/services" element={<Services />} />
              <Route path="/nfts" element={<NftStudio />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </Web3Provider>
  </ErrorBoundary>
);

export default App;
